export default __webpack_public_path__ + "static/media/circulo2.6149d5e0.svg";